import { Link } from "react-router-dom";
import Header from "../../components/header/Header";

const Error404 = () =>{
    return(
        <div>
            <Header headerType="detail" headerTitle="" arrowYn={false} closeYn={true}/>
            <div id="container">		
                <div className="content">
                    
                    <div className="vhBox bottomBtn">			
                        <div className="innerBox">
                            <div className="IconWrap">
                                {/* 아이콘 리스트
                                기본 = default , 안내 = .guidance , 실패 = .fail , 성공 = .success */}
                                <div className="icon default"></div>
                                <p className="mediumTit txtBold">
                                    페이지를 찾을 수 없습니다			
                                </p>
                                <p className="normalTit txtBlack2 mt24">
                                    페이지가 존재하지 않거나,<br/>
                                    사용할 수 없는 페이지 입니다.
                                </p>
                                <p className="normalTit txtBlack2 mt8">
                                    서류제출 메인 화면으로 이동하겠습니다.
                                </p>
                            </div>
                        </div>
                    </div>			
                </div>
                                    
                <div className="fullbtn">
                    {/* 활성화  .on */}
                    <Link to="/" className="btn on">확인</Link>
                </div>
            </div>

        </div>
    );
}
export default Error404;


